export default __webpack_public_path__ + "static/media/77.5dd25027.gif";